<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; margin-top:3pc"></p>
<p class="dedication"><a id="dedi"></a>This work is dedicated to the memory of the honorable Abdul Aziz former</p>
<p class="dedication">Senior Advocate of the Supreme Court of Bangladesh</p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="center"><img alt="Image" src="images/U002.jpg"/></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="dedication">“Exemplary people understand things in terms of justice.”</p>
<p class="dedication">—<i>Analects of Confucius</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?52907b44